<template>
  <div class="sponsor-assets-table" v-if="!loading && assetsData">
    <div class="sponsor-assets-table-header">
      <h2 class="sponsor-assets-table-title q-mb-md">
        {{ $t('dashboard.sponsorAssetsTable.title') }}
      </h2>

      <div class="stats-grid">
        <StatsCard
          :label="$t('dashboard.sponsorAssetsTable.totalEventPhotos')"
          :value="assetsData.total_event_photos || 0"
          icon="photo_library"
          color="#ff69b4"
        />
        <StatsCard
          :label="$t('dashboard.sponsorAssetsTable.totalSponsoredPhotos')"
          :value="assetsData.total_sponsored_photos || 0"
          icon="verified"
          color="#5a67d8"
        />
        <StatsCard
          :label="$t('dashboard.sponsorAssetsTable.exposureRatio')"
          :value="formatRatio(assetsData.sponsor_exposure_ratio)"
          icon="insights"
          color="#2b6cb0"
        />
        <StatsCard
          :label="$t('dashboard.sponsorAssetsTable.totalDetections')"
          :value="assetsData.total_detections || 0"
          icon="track_changes"
          color="#43a047"
        />
      </div>
    </div>
    <div class="sponsor-assets-table-wrapper">
      <q-table
        :rows="assetsData.assets_detections || []"
        :columns="columns"
        row-key="asset_id"
        hide-pagination
        :rows-per-page-options="[0]"
        flat
        bordered
      >
        <template v-slot:body-cell-image="props">
          <q-td :props="props">
            <q-img
              :src="props.row.url"
              style="width: 50px; height: 50px"
              fit="cover"
              class="rounded-borders"
            >
              <template v-slot:error>
                <div
                  class="absolute-full flex flex-center bg-negative text-white"
                >
                  <q-icon name="broken_image" />
                </div>
              </template>
            </q-img>
          </q-td>
        </template>
        <template v-slot:no-data>
          <div class="full-width row flex-center q-gutter-md">
            <span>
              {{ $t('dashboard.sponsorAssetsTable.noData') }}
            </span>
          </div>
        </template>
      </q-table>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import StatsCard from './StatsCard.vue';

export default {
  name: 'SponsorAssetsTable',
  components: {
    StatsCard,
  },
  props: {
    eventId: {
      type: [Number, String],
      required: true,
    },
  },
  computed: {
    ...mapState('dashboardEvents', {
      assetsData: (state) => state.sponsorAssetsDashboardData,
      loading: (state) => state.loading,
    }),
    columns() {
      return [
        {
          name: 'image',
          align: 'left',
          label: this.$t('dashboard.sponsorAssetsTable.image'),
          field: 'url',
          sortable: false,
        },
        {
          name: 'name',
          required: true,
          label: this.$t('dashboard.sponsorAssetsTable.assetName'),
          align: 'left',
          field: 'name',
          sortable: true,
        },
        {
          name: 'detections_count',
          align: 'center',
          label: this.$t('dashboard.sponsorAssetsTable.detectionsCount'),
          field: 'detections_count',
          sortable: true,
        },
      ];
    },
  },
  methods: {
    ...mapActions('dashboardEvents', ['fetchSponsorAssetsDashboardData']),
    formatRatio(ratio) {
      if (!ratio && ratio !== 0) return '0%';

      return (ratio * 100).toFixed(2) + '%';
    },
  },
  async mounted() {
    if (this.eventId) {
      await this.fetchSponsorAssetsDashboardData(this.eventId);
    }
  },
};
</script>

<style lang="scss" scoped>
.sponsor-assets-table {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;

  &-wrapper {
    padding: 0 0 8px 0;
  }

  &-header {
    padding: 24px;
    border-bottom: 1px solid #edf2f7;
    background: linear-gradient(to bottom, #ffffff, #f6f6f6);
  }

  &-title {
    font-size: 1.25rem;
    font-weight: 700;
    color: #1a202c;
    margin: 0 0 20px 0;
    letter-spacing: -0.025em;
  }
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 16px;
  width: 100%;


  @media (min-width: $breakpoint-sm-min) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: $breakpoint-lg-min) {
    grid-template-columns: repeat(4, 1fr);
  }
}
</style>
